export default {
  data() {
    return {
      matchMenuItems: [],
    };
  },
  created() {
    this.matchMenuItems = [
      {
        key: 'schedule-match',
        title: 'Change schedule of the match',
        handler: this.openMatchSchedulingModal,
        disabled: false,
        icon: 'calendar',
      },
      {
        key: 'match-chat',
        title: 'Chat with participants',
        handler: this.openChat,
        defaultOptions: {
          conversationType: 'group_chat',
          targetGroup: 'all',
        },
        disabled: false,
        icon: 'chat-group',
      },
      {
        key: 'view-results',
        title: 'View results',
        handler: this.openMatchResultsView,
        disabled: false,
        icon: 'scales',
      },
      {
        key: 'edit-results',
        title: 'Edit results',
        handler: this.openMatchResultsEdit,
        disabled: false,
        icon: 'scales',
      },
      {
        key: 'tech-win-player-1',
        disabled: false,
        icon: 'cup',
      },
      {
        key: 'tech-win-player-2',
        disabled: false,
        icon: 'cup',
      },
      {
        key: 'force-reset',
        title: 'Reset match',
        handler: this.confirmResetMatch,
        disabled: false,
        icon: 'reset',
      },
      {
        key: 'force-start',
        title: 'Force start',
        handler: this.confirmStartMatch,
        disabled: false,
        icon: 'play-2',
      },
      {
        key: 'force-finish',
        title: 'Force finish',
        handler: this.confirmFinishMatch,
        disabled: false,
        icon: 'stop',
      },
      // {
      //   key: 'match-channel',
      //   title: 'Channel with participants',
      //   handler: this.openChat,
      //   defaultOptions: {
      //     conversationType: 'channel',
      //     targetGroup: 'all',
      //   },
      //   disabled: false,
      // },
    ];
  },
  methods: {
    getMatchMenuItems(items = []) {
      return this.matchMenuItems.filter(item => {
        return items.includes(item.key);
      });
    },
  },
};
